/*
 * File per la definizione dei Service Angular, ovvero oggetti che espongono funzionalita' condivise tra diversi Controller:
 * https://code.angularjs.org/1.5.8/docs/guide/services
 */
define([
    'angular'
],
    function (angular) {

        var storageServices = angular.module('storageServices', []);

        storageServices.service('StorageService', ['$log', StorageService]);

        /*
         * Service per la condivisione di risorse tra diversi Controller
         */
        function StorageService($log) {
            var _resources = {};

            /*
             * Metodi pubblici esposti dal Service
             */
            this.setResource = function (key, data) {
                $log.debug('setResource: ' + key + ' = ' + data);
                _resources[key] = data;
            };
            this.getResource = function (key) {
                $log.debug('getResource: ' + key);
                return _resources[key];
            };
        }

        storageServices.service('UserService', ['$log', 'StorageService', function ($log, StorageService) {
            var _resources = {};

            var storageKey = 'user';

            this.setUser = function (data) {
                if (data) {
                    $log.info('Caricato Utente: ' + data.userAuth.codiceFiscale);
                } else {
                    $log.info('Rimosso Utente');
                }

                StorageService.setResource(storageKey, data)
            };

            this.getUser = function () {
                return StorageService.getResource(storageKey);
            }
        }]);

        storageServices.service('listeForm', ['$log', 'StorageService', function ($log, StorageService) {
            var _resources = {};

            this.setListe = function (key, data) {

                StorageService.setResource(key, data)
            };

            this.getListe = function (key) {
                return StorageService.getResource(key);
            }

        }]);

        storageServices.service('ErrorService', ['$log', function ($log) {

            this.getErrore = function (errore) {
                if (errore === undefined) return "campo undefined";
                if (errore.dataMaggioreOggi) return "Data di impegno trasmissione non pu\u00F2 essere maggiore della data odierna"
                if (errore.valoreNonValido) return "Valore non accettabile"
                if (errore.parse) return "Campo formalmente errato";
                if (errore.required) return "Campo Obbligatorio";
                if (errore.minlength) return "Lunghezza minima errata";
                if (errore.maxlength) return "Lunghezza massima errata";
                if (errore.invalid) return "Campo non valido";
                if (errore.pattern) return "Valore non valido";
                if (errore.cfFirmatarioPnf) return "Codice fiscale di persona non fisica";
                if (errore.cfNonTrovato) return "Codice fiscale non risulta valido"
                if (errore.cfSocietaNonValido) return "Il Codice fiscale societa' non valido";
                if (errore.file) return "File inserito non valido per presenza di virus"
                if (errore.piva) return "E' stata inserita una P.Iva in campo di un codice fiscale"
                return "Campo formalmente errato";

            };
        }]);

        return storageServices;
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/services/storage-services.js
// module id = 47
// module chunks = 1